import loadable from '@loadable/component';
import { LoadableFunctionalComponent } from '../../../../../../../utils/index.ts';
import { CircleButtonLoader } from '../../../../../../../shared/index.ts';
import { ButtonViewProps } from '../../../../../types.ts';

export const CircleButton = loadable(() => import('./component/index.tsx'), {
  resolveComponent: (components) => components.CircleButtonComponent,
  fallback: <CircleButtonLoader />,
}) as LoadableFunctionalComponent<ButtonViewProps>;
